import { createSlice } from '@reduxjs/toolkit';
import { PromiseToPayWithUser } from '@dill/dill-shared';
import {
  getBuyerPromiseToPaysExtraReducer,
  getSupplierPromiseToPaysExtraReducer,
  createPromiseToPayExtraReducer,
  updatePromiseToPayExtraReducer,
  cancelPromiseToPayExtraReducer,
  getActivePromisesForInvoicesExtraReducer,
  deletePromiseToPayExtraReducer,
} from '../reducers/promiseToPayReducers';

export interface PromiseToPayInitialState {
  loadingList: string[];
  error: string | null;
  buyerPromiseToPays: PromiseToPayWithUser[];
  supplierPromiseToPays: PromiseToPayWithUser[];
  activePromisesByInvoice: Record<string, PromiseToPayWithUser[]>;
}

const initialState: PromiseToPayInitialState = {
  loadingList: [],
  error: null,
  buyerPromiseToPays: [],
  supplierPromiseToPays: [],
  activePromisesByInvoice: {},
};

export const promiseToPaySlice = createSlice({
  name: 'promiseToPays',
  initialState,
  reducers: {
    resetPromiseToPayRootState: () => initialState,
    clearBuyerPromiseToPays: (state) => {
      state.buyerPromiseToPays = [];
    },
  },
  extraReducers(builder) {
    getBuyerPromiseToPaysExtraReducer(builder);
    getSupplierPromiseToPaysExtraReducer(builder);
    createPromiseToPayExtraReducer(builder);
    updatePromiseToPayExtraReducer(builder);
    cancelPromiseToPayExtraReducer(builder);
    getActivePromisesForInvoicesExtraReducer(builder);
    deletePromiseToPayExtraReducer(builder);
  },
});

export const { resetPromiseToPayRootState, clearBuyerPromiseToPays } = promiseToPaySlice.actions;
